import * as React from 'react'
import { Link } from 'gatsby'
import resolveLink from 'utils/resolveLink'
import clsx from 'clsx'

export default function SingleLink({
	_type,
	label,
	title,
	url,
	seo,
	className,
}) {
	return (
		<Link
			className={clsx(
				'technical-lg no-underline transition-colors hover:text-ft-green',
				className,
			)}
			to={url || resolveLink({ _type, seo })}
		>
			{label || title}
		</Link>
	)
}
